import React, { Component } from 'react';
import OpbFloorsItem from './OpbFloorsItem';


class OpbFloorsMng extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isMobile: false,
        }
    }

    componentDidMount = () => {
        window.addEventListener("resize", this.resize.bind(this));
        this.resize();
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.resize.bind(this));
    }
    
    resize() {
        let isMobile = (window.innerWidth < 992);
        if (isMobile !== this.state.isMobile) {
            this.setState({isMobile: isMobile});
        }
    }

    handleValueChange = (index, name, value) => {
    // 변경된 사항(층 표시, 층 정보, 편의시설 선택)을 PropertiesDialog 컴포넌트에 전달 
        let preFloorsList = [...this.props.floorsList];
        preFloorsList.map((floorInfo, i) => {
            if (i === index) floorInfo[name] = value;
            return floorInfo;
        });

        this.props.setFloorsStatus('floorsList', preFloorsList);
    };
    
    render() {
        return (
            <>
                {/* <!-- 기본설정_층설정 --> */}
                <div className="s-cont-wrap">
                    <div className="s-flex-auto">
                        <div className="s-table-wrap" style={{width: this.state.isMobile ? '500px' : '100%'}}>
                            <table className="w100per">
                                <colgroup>
                                    <col style={{width:"10%"}} />
                                    <col style={{width:"10%"}} />
                                    <col />
                                    <col style={{width:"40%"}} />
                                </colgroup>
                                <thead className="table-head" >
                                    <tr>
                                        <th scope="col">번호</th>
                                        <th scope="col">층</th>
                                        <th scope="col">층 정보</th>
                                        <th scope="col">편의 시설 선택</th>
                                    </tr>
                                </thead>
                                <tbody className="table-body">
                                {this.props.floorsList && this.props.floorsList.length > 0 &&
                                    this.props.floorsList.map((floor, i) => {
                                        return <OpbFloorsItem key={i} floor={floor} index={i} handleValueChange={this.handleValueChange}/>
                                    })
                                }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

export default OpbFloorsMng;